import React, { useState, useEffect } from 'react';
import { api } from '../utils/apiClient';
import { Row, Col, Select, Input, Button, Space, Card, Typography } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import RichTextEditor from './common/RichTextEditor';

const { Title } = Typography;

function Validation() {
  const [documentTypes, setDocumentTypes] = useState([]);
  const [documentType, setDocumentType] = useState('');
  const [metadataFields, setMetadataFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [generatedDocument, setGeneratedDocument] = useState('');

  useEffect(() => {
    api.get('/metadata/types')
      .then(response => setDocumentTypes(response.data))
      .catch(error => console.error('Error fetching document types:', error));
  }, []);

  useEffect(() => {
    if (documentType) {
      api.get('/metadata/fields', { params: { documentType } })
        .then(response => {
          setMetadataFields(response.data);
          const initialFormData = response.data.reduce((acc, field) => ({
            ...acc,
            [field.field_name]: ''
          }), {});
          setFormData(initialFormData);
        })
        .catch(error => console.error('Error fetching metadata fields:', error));
    }
  }, [documentType]);

  const handleInputChange = (fieldName, event) => {
    setFormData({
      ...formData,
      [fieldName]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      documentType: documentType,
      fields: metadataFields.map(field => ({
        field_label: field.field_label,
        field_name: formData[field.field_name] || ''
      }))
    };

    api.post('/generate_html_document', payload)
      .then(response => {
        const { htmlContent } = response.data;
        if (htmlContent) {
          setGeneratedDocument(htmlContent);
        } else {
          console.error('Response does not contain htmlContent');
        }
      })
      .catch(error => {
        console.error('Error generating document:', error.response.data);
      });
  };


  const handleCancel = () => {
    setFormData({});
    setDocumentType('');
    setGeneratedDocument('');
  };

  const saveDocumentEdits = () => {
    api.post('/save_edited_document', { content: generatedDocument })
      .then(() => console.log('Document saved successfully'))
      .catch(error => console.error('Error saving document:', error));
  };

  const renderFormField = (field) => (
    <div key={field.id} style={{ marginBottom: '16px' }}>
      <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>
        {field.field_name}
      </label>
      <Input
        placeholder={field.field_name}
        value={formData[field.field_name] || ''}
        onChange={(e) => handleInputChange(field.field_name, e)}
      />
    </div>
  );

  return (
    <div>
      <Row gutter={24}>
        <Col xs={24} md={16}>
          <Card style={{ marginBottom: '16px' }}>
            <RichTextEditor
              value={generatedDocument}
              onChange={setGeneratedDocument}
              placeholder="Your validation document content will appear here..."
            />
          </Card>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={saveDocumentEdits}
            size="large"
          >
            Save Changes
          </Button>
        </Col>

        <Col xs={24} md={8}>
          <Card>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                  Document Type
                </label>
                <Select
                  placeholder="Select document type"
                  value={documentType || undefined}
                  onChange={setDocumentType}
                  style={{ width: '100%' }}
                  options={documentTypes.map((type, index) => ({
                    key: index,
                    label: type,
                    value: type
                  }))}
                />
              </div>

              {documentType && (
                <>
                  <Title level={5} style={{ marginTop: '16px', marginBottom: '16px' }}>
                    Document Metadata
                  </Title>
                  <form onSubmit={handleSubmit}>
                    {metadataFields.map(field => renderFormField(field))}
                    <Space style={{ marginTop: '16px' }}>
                      <Button onClick={handleCancel} type="default">
                        Cancel
                      </Button>
                      <Button type="primary" htmlType="submit">
                        Save
                      </Button>
                    </Space>
                  </form>
                </>
              )}
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Validation;
